import React, { useRef, useEffect } from 'react';
import * as S from './styled';
import * as SS from '../../styled';

export const ReviewsSlider = ({ t }) => {
  const sliderRef = useRef(null);
  const isRtl = document.documentElement.getAttribute('dir') === 'rtl';

  const reviews = [
    {
      title: t('review_title_1'),
      text: t('review_text_1'),
      author: 'Kevin Peters',
    },
    {
      title: t('review_title_2'),
      text: t('review_text_2'),
      author: 'John Lee',
    },
    {
      title: t('review_title_3'),
      text: t('review_text_3'),
      author: 'Megan Smith',
    },
  ];

  useEffect(() => {
    const container = sliderRef.current;
    if (!container) return;

    requestAnimationFrame(() => {
      const second = container.querySelector("[data-index='1']");
      second?.scrollIntoView({
        inline: 'center',
        block: 'nearest',
        behavior: 'auto',
      });
    });
  }, [isRtl]);

  return (
    <S.ReviewsSliderContainer>
      <S.ReviewsTitle>{t('most_helpful')}</S.ReviewsTitle>
      <S.ReviewsSliderWrapper ref={sliderRef}>
        {reviews.map((review, index) => (
          <S.ReviewCard key={index} data-index={index}>
            <S.ReviewTitle>{review.title}</S.ReviewTitle>
            <S.ReviewRating>
              <picture>
                <source
                  media="(prefers-color-scheme: dark)"
                  srcSet="./assets/storeV2/stars-rating-dark.svg"
                />
                <SS.Image
                  src="./assets/storeV2/stars-rating.svg"
                  alt="5 stars"
                  $width={97}
                  $height={16}
                />
              </picture>
              <S.ReviewAuthor>
                {t('by')} {review.author}
              </S.ReviewAuthor>
            </S.ReviewRating>
            <S.ReviewText>{review.text}</S.ReviewText>
          </S.ReviewCard>
        ))}
      </S.ReviewsSliderWrapper>
    </S.ReviewsSliderContainer>
  );
};
